import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TemplatesService } from "../templates.service";
import { Router } from "@angular/router";
import { SocialTemplate } from "../interface/social";
import { PaginationInstance } from "ngx-pagination";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";

@Component({
  selector: "app-multi-select-template-section",
  templateUrl: "./multi-select-template-section.component.html",
  styleUrls: ["./multi-select-template-section.component.scss"],
})
export class MultiSelectTemplateSectionComponent implements OnInit {
  @ViewChild("templateModal", { static: true })
  templateModal: ElementRef;

  @Input() isMainPage: boolean;
  @Input() maxTemplateSelectionLimit = 0;
  @Input() maxTemplateDisplay: number = 9;
  @Input() isZceppaTemplateSection: boolean;
  @Input() hideDelete: boolean = false;
  @Input("hideContent") hideContent: boolean = false;
  @Input() defaultTemplate: string[] | null = [];
  @Input() isTemplateModal: boolean;
  @Input() feature:
    | "social"
    | "messaging"
    | "reply"
    | "appointment"
    | "mystore"
    | "interact";

  @Output() onTemplateSelect: EventEmitter<SocialTemplate> =
    new EventEmitter<SocialTemplate>();
  @Output() onDeleteTemplate: EventEmitter<string> = new EventEmitter<string>();
  @Output() updatedSearchText: EventEmitter<string> =
    new EventEmitter<string>();
  @Output() selectedIdArray = new EventEmitter<string[]>();
  @Output() moreTemplateClick = new EventEmitter<boolean>();

  private _templates = [];
  templatesInPage: any[];
  templatesArrayInModal: any[];
  private _selectedTemplate: SocialTemplate = null;
  @Input("templates")
  set templates(value) {
    this._templates = value ?? [];
  }
  get templates() {
    return this._templates;
  }

  @Input()
  set selectedTemplate(value) {
    this._selectedTemplate = value;
  }
  get selectedTemplate() {
    return this._selectedTemplate;
  }
  paginationConfig: PaginationInstance;
  closeResult: string;
  searchText: string = "";
  selectedTemplateIds = [];
  searchUpdate = new Subject<string>();

  @Input("searchTextInput")
  set searchTextInput(value) {
    this.searchText = value;
  }
  get searchTextInput() {
    return this.searchText;
  }

  constructor(
    private modalService: NgbModal,
    private templatesService: TemplatesService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.init();
    this.moveSelectedTemplate();
    this.templatesService.resetFields$.subscribe((isReset) => {
      if (isReset) {
        this.resetFields();
      }
    });
    this.templatesService.updateTemplatesArrPagination$.subscribe(
      (response) => {
        if (response !== null) {
          this.paginationConfig.totalItems = response || 0;
        }
      }
    );

    this.searchUpdate.pipe(debounceTime(300)).subscribe((value) => {
      this.updatedSearchText.emit(this.searchText);
    });
  }

  isDefaultTemplate(template: any) {
    let defaultTemplate = this.defaultTemplate?.some(
      (eachTemplate) => eachTemplate == template?.id
    );
    return defaultTemplate || false;
  }

  init() {
    this.templatesArrayInModal = this.templates;
    this.selectedTemplateIds = [];
    this.templatesArrayInModal.forEach((element: any) => {
      if (element?.is_selected) {
        this.selectedTemplateIds.push(element.id);
      }
    });
    this.paginationConfig = {
      id: "templates",
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.templates?.length,
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.templates && changes.templates.currentValue !== undefined) {
      let templates = changes.templates.currentValue;
      this.templates = templates;
      this.templatesInPage = this.templates;
      this.init();
    }
  }
  ngOnDestroy() {
    this.onTemplateSelect.unsubscribe();
  }

  getCurrentPage() {
    return this.paginationConfig?.currentPage;
  }

  onSelectTemplate(template: SocialTemplate) {
    this.selectedTemplate = template;
    this.onTemplateSelect.emit(template);
  }

  onDeleteTemplateAction(templateID: string) {
    this.onDeleteTemplate.emit(templateID);
  }
  moveSelectedTemplate(isFromModal?: boolean) {
    if (isFromModal) {
      let templateArray = this.selectedTemplate
        ? [{ ...this.selectedTemplate }, ...this.filteredArrayOfTemplates()]
        : [...this.filteredArrayOfTemplates()];
      this.templatesInPage = templateArray;
    } else {
      this.templatesInPage = this.templates;
    }
  }

  filteredArrayOfTemplates() {
    const filteredArrayOfTemplates = this.templates.filter(
      (template) => template?.id !== this.selectedTemplate?.id
    );
    return filteredArrayOfTemplates;
  }
  // Used in HTML
  filterRecentTemplates(templates?: any[]) {
    const filterRecentTemplates =
      (templates ? templates : this.templatesArrayInModal).filter(
        (template) => template?.is_recently_used
      ) || [];
    return [...filterRecentTemplates];
  }
  lastIndex() {
    const filterRecentTemplates =
      this.templatesArrayInModal.filter(
        (template) => template?.is_recently_used
      ) || [];
    return [...filterRecentTemplates].length;
  }
  filterRemainingTemplates() {
    const filterRemainingTemplates =
      this.templates.filter((template) => !template?.is_recently_used) || [];
    return [...filterRemainingTemplates];
  }
  closeModal() {
    this.isTemplateModal = false;
    this.modalService.dismissAll();
  }
  resetFields() {
    this.searchText = "";
  }

  redirectToMessaging() {
    this.router.navigate(["/settings/messaging-template"]);
  }

  openModal(modal: any) {
    this.isTemplateModal = true;
    this.modalService
      .open(modal, {
        backdropClass: "light-blue-backdrop",
        size: "lg",
        backdrop: "static",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    this.isTemplateModal = false;
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  getHeight(perfectScrollBar) {
    if (perfectScrollBar) {
      const y =
        perfectScrollBar?.directiveRef?.elementRef?.nativeElement?.getBoundingClientRect()
          ?.y || 0;
      const height = window.innerHeight || 0;
      return `${height - y - 40}px`;
    } else {
      return "250px";
    }
  }

  isReviewTemplateType(template: any) {
    let isReviewComponent = template?.is_review_share_template === true;
    return isReviewComponent ? true : false;
  }

  onChangeTemplateSelection($event: boolean, template: any) {
    template.is_selected = $event;

    if ($event === true) {
      this.selectedTemplateIds.push(template.id);
    } else {
      const indexOfId = this.selectedTemplateIds.findIndex(
        (obj) => obj === template.id
      );

      if (indexOfId > -1) {
        this.selectedTemplateIds.splice(indexOfId, 1);
      }
    }
    this.selectedIdArray.emit(this.selectedTemplateIds);
  }

  onMoreTemplateClick() {
    this.moreTemplateClick.emit(true);
  }

  isTemplateLimitReached() {
    return this.selectedTemplateIds.length >= this.maxTemplateSelectionLimit;
  }
}
